if(document.querySelector('.input-listen')){
    const inputListeners = document.querySelectorAll('.input-listen')
    inputListeners.forEach(listeninput => {
        const listenAll = listeninput.getAttribute('data')
        const listenArr = listenAll.split('.')
        const radios = document.querySelectorAll('.radio-box-dekaz.'+listenArr[0]+' input[type="radio"]')
        radios.forEach(radio => {
            if(radio.classList.contains(listenArr[1])) {
                radio.addEventListener('click', ()=>{
                    // console.log(radio.value,'ON')
                    listeninput.classList.add('active')
                    
                })
            }else{
                radio.addEventListener('click', ()=>{
                    // console.log(radio.value,'OFF')
                    listeninput.classList.remove('active')
                    
                })
            }
            
        });
    });
}